// 9fbef606107a605d69c0edbcd8029e5d
import constants from './StyliticsProductTabList.constants';

export const styliticsProductTabListDataReq = (payload = {}) => {
  return {
    type: constants.STYLITICS_PRODUCT_TAB_LIST_REQ,
    payload,
  };
};

export const styliticsProductTabListDataReqforOutfit = (payload = {}) => {
  return {
    type: constants.STYLITICS_PRODUCT_TAB_LIST_REQ_OUTFIT,
    payload,
  };
};

export const styliticsProductTabListDataSuccess = (payload = {}) => {
  return {
    type: constants.STYLITICS_PRODUCT_TAB_LIST_SUCCESS,
    payload,
  };
};

export const outfitPLPDataSuccess = (payload = {}) => {
  return {
    type: constants.OUTFIT_PLP_DATA_SUCCESS,
    payload,
  };
};

export const outfitPLPDataFail = (payload = {}) => {
  return {
    type: constants.OUTFIT_PLP_DATA_FAIL,
    payload,
  };
};

export const styliticsProductTabListDataFail = (payload = {}) => {
  return {
    type: constants.STYLITICS_PRODUCT_TAB_LIST_FAIL,
    payload,
  };
};

export const styliticsFlushData = (payload = {}) => {
  return {
    type: constants.STYLITICS_FLUSH_DATA,
    payload,
  };
};

export const isFetchingDataForOutfit = (payload = true) => {
  return {
    type: constants.IS_FETCHING_DATA_FOR_OUTFIT,
    payload,
  };
};

export const setSeoHeaderCopy = (payload) => {
  return {
    payload,
    type: constants.SET_OUTFIT_SEO_DATA,
  };
};

export const setBagOutfitProducts = (payload = {}) => {
  return {
    type: constants.BAG_OUTFIT_PRODUCTS,
    payload,
  };
};

export const fetchBagOutfitProducts = (payload = {}) => {
  return {
    type: constants.STYLITICS_PRODUCT_TAB_LIST_BAG,
    payload,
  };
};

export default {
  styliticsProductTabListDataReq,
  styliticsProductTabListDataReqforOutfit,
  styliticsProductTabListDataSuccess,
  styliticsProductTabListDataFail,
  styliticsFlushData,
  outfitPLPDataSuccess,
  outfitPLPDataFail,
  setBagOutfitProducts,
  fetchBagOutfitProducts,
};
